import Assistant from './components/Assistant/Assistant';
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { setHistory } from './services/historyService';
import Login from "./screens/Login";
import dashboard from "./screens/Dashbord/Dashbord";
import demographic from "./screens/Dashbord/Demographic";
import ioT from "./screens/Dashbord/IoT";
import NavbarMenu from "./components/NavbarMenu";
import "./components/ManagementPage.css";
import appCalendar from "./screens/App/Calendar";
import appTaskbar from "./screens/App/Taskbar";
import registration from "./screens/Auth/Registration";
import lockscreen from "./screens/Auth/Lockscreen";
import forgotpassword from "./screens/Auth/ForgotPassword";
import page404 from "./screens/Auth/Page404";
import page403 from "./screens/Auth/Page403";
import page500 from "./screens/Auth/Page500";
import page503 from "./screens/Auth/Page503";
import maintanance from "./screens/Pages/Maintanance";
import { onLoggedin, updateUserInfo } from "./actions";
import PrivateRoute from "./components/PrivateRoute";
import users from "./screens/users/Users"
import UserDetail from "./screens/users/UserDetail";
import UserAdd from "./screens/users/UserAdd";
import Branches from "./screens/Branches/Branches";
import BranchAdd from "./screens/Branches/BranchAdd";
import BranchDetail from "./screens/Branches/BranchDetail";
import Services from "./screens/Services/Services";
import ServiceAdd from "./screens/Services/ServiceAdd";
import ServiceDetail from "./screens/Services/ServiceDetail";
import Appointments from "./screens/Appointments/Appointments";
import AppointmentDetail from "./screens/Appointments/AppointmentDetail";
import Types from "./screens/OperationTypes/Types";
import TypeAdd from "./screens/OperationTypes/TypeAdd";
import TypeDetail from "./screens/OperationTypes/TypeDetail";
import Customers from "./screens/Customers/Customers";
import CustomerDetail from "./screens/Customers/CustomerDetail";
import CustomerAdd from "./screens/Customers/CustomerAdd";
import Messages from "./screens/Messages/Messages";
import MessageDetail from "./screens/Messages/MessageDetail";
import Vehicles from "./screens/Vehicles/Vehicles";
import VehicleAdd from "./screens/Vehicles/VehicleAdd";
import VehicleDetail from "./screens/Vehicles/VehicleDetail";
import Status from "./screens/Status/Status";
import StatuAdd from "./screens/Status/StatuAdd";
import StatuDetail from "./screens/Status/StatuDetail";
import Offers from "./screens/Offers/Offers";
import OfferAdd from "./screens/Offers/OfferAdd";
import OfferDetail from "./screens/Offers/OfferDetail";
import OfferPreview from "./screens/Offers/OfferPreview";
import Business from "./screens/Settings/Business";
import EmailAndSms from "./screens/Settings/EmailAndSms";
import NotificationPrefers from "./screens/Settings/NotificationPrefers";
import Roles from "./screens/Roles/Roles";
import RoleAdd from "./screens/Roles/RoleAdd";
import RoleDetail from "./screens/Roles/RoleDetail";
import Subsciption from "./screens/Settings/Subsciption";
import MySubsciption from "./screens/Settings/MySubsciption";
import PricingManagement from "./screens/Admin/PricingManagement";
import CampaignManagement from "./screens/Admin/CampaignManagement";
import VehicleAvatarManagement from "./screens/Admin/VehicleAvatarManagement";
import VehicleBrandManagement from "./screens/Admin/VehicleBrandManagement";
import ServiceReports from "./screens/Reports/ServiceReports";
import CustomerReports from "./screens/Reports/CustomerReports";
import ReportsCenter from "./screens/ReportsV2/ReportsCenter";
import { ToastContainer } from "react-toastify";
import Tickets from "./screens/Tickets/Tickets";
import TicketAdd from "./screens/Tickets/TicketAdd";
import TicketDetail from "./screens/Tickets/TicketDetail";
import QrGenerate from "./screens/Settings/QrGenerate";
import FinanceReports from "./screens/Reports/FinanceReports";
import Incomes from "./screens/Incomes/Incomes";
import IncomeAdd from "./screens/Incomes/IncomeAdd";
import IncomeDetail from "./screens/Incomes/IncomeDetail";
import CategoryAdd from "./screens/IncomeExpenseCategories/CategoryAdd";
import CategoryDetail from "./screens/IncomeExpenseCategories/CategoryDetail";
import Categories from "./screens/IncomeExpenseCategories/Categories";
import Expenses from "./screens/Expenses/Expenses";
import ExpenseAdd from "./screens/Expenses/ExpenseAdd";
import ExpenseDetail from "./screens/Expenses/ExpenseDetail";
import Receivables from "./screens/Receivables/Receivables";
import ReceivableAdd from "./screens/Receivables/ReceivableAdd";
import ReceivableDetail from "./screens/Receivables/ReceivableDetail";
import IncomeExpenseReports from "./screens/Reports/IncomeExpenseReports";
import ReceivableReports from "./screens/Reports/ReceivableReports";
import NotificationSendAndHistory from "./screens/SpecialNotification/NotificationSendAndHistory";
import InvoiceDetail from "./screens/Ksoft/InvoiceDetail";
import ServiceAddWithAI from "./screens/Services/ServiceAddWithAI";
import MotoAdd from "./screens/Vehicles/MotoAdd";
import Motos from "./screens/Vehicles/Motos";
import MotoDetail from "./screens/Vehicles/MotoDetail";
import ServicesMotos from "./screens/Services/ServicesMotos";
import ServiceMotoAdd from "./screens/Services/ServiceMotoAdd";
import ServiceMotoDetail from "./screens/Services/ServiceMotoDetail";
import Suppliers from "./screens/Customers/Suppliers";
import EInvoiceInbox from "./screens/Parasut/EInvoiceInbox";
import ServiceInvoicesByStatus from "./screens/Ksoft/ServiceInvoicesByStatus";
import ServiceInvoices from "./screens/Ksoft/ServiceInvoices";
import ManualInvoice from "./screens/Invoice/ManualInvoice";
import ManualInvoiceList from "./screens/Invoice/ManualInvoiceList";
import ManualInvoiceDetail from "./screens/Invoice/ManualInvoiceDetail";
import Documents from "./screens/Ksoft/Documents";
import EInvoiceInboxDetails from "./screens/Parasut/EInvoiceInboxDetails";
import BankAccounts from "./screens/Settings/BankAccounts";
import BankAccountDetails from "./screens/Settings/BankAccountDetails";
import IncomeNotificationHistory from "./screens/SpecialNotification/IncomeNotificationHistory";
import DocumentDetail from "./screens/Ksoft/DocumentDetail";
import Credits from "./screens/Ksoft/Credits";
import InvoiceHtmlShow from "./screens/Ksoft/InvoiceHtmlShow";
import EarsivInvoiceHtmlShow from "./screens/Ksoft/EarsivInvoiceHtmlShow";
import DocumentHtmlShow from "./screens/Ksoft/DocumentHtmlShow";
import SupplierDetail from "./screens/Customers/SupplierDetail";
import ReceivableSupplierDetail from "./screens/Receivables/ReceivableSupplierDetail";
import ReceivableSuppliers from "./screens/Receivables/ReceivableSuppliers";
import ReceivableSupplierAdd from "./screens/Receivables/ReceivableSupplierAdd";
import SupplierPaymentDetail from "./screens/Customers/SupplierPaymentDetail";
import SupplierPaymentAdd from "./screens/Customers/SupplierPaymentAdd";
import SearchParts from "./screens/App/SearchParts";
import BuyAiCredits from "./screens/App/BuyAiCredits";
import LaborCommissions from "./screens/Finance/LaborCommissions";
import Warehouses from "./screens/Stock/Warehouses/Warehouses";
import WarehouseAdd from "./screens/Stock/Warehouses/WarehouseAdd";
import WarehouseDetail from "./screens/Stock/Warehouses/WarehouseDetail";
import StockItems from "./screens/Stock/Items/StockItems";
import StockItemAdd from "./screens/Stock/Items/StockItemAdd";
import StockItemDetail from "./screens/Stock/Items/StockItemDetail";
import StockCategories from "./screens/Stock/Categories/StockCategories";
import StockCategoryAdd from "./screens/Stock/Categories/CategoryAdd";
import StockCategoryDetail from "./screens/Stock/Categories/CategoryDetail";
import StockMovements from "./screens/Stock/Movements/StockMovements";
import StockMovementAdd from "./screens/Stock/Movements/StockMovementAdd";
import StockMovementDetail from "./screens/Stock/Movements/StockMovementDetail";
import StockTransfers from "./screens/Stock/Transfers/StockTransfers";
import StockTransferAdd from "./screens/Stock/Transfers/StockTransferAdd";
import StockTransferDetail from "./screens/Stock/Transfers/StockTransferDetail";
import StockAlerts from "./screens/Stock/Alerts/StockAlerts";
import LowStockReport from "./screens/Stock/Reports/LowStockReport";
import SalesReport from "./screens/Stock/Reports/SalesReport";
import StockSummaryReport from "./screens/Stock/Reports/StockSummaryReport";
import WarehouseStockReport from "./screens/Stock/Reports/WarehouseStockReport";
import StockMovementReport from "./screens/Stock/Reports/StockMovementReport";
window.__DEV__ = true;
class App extends React.Component {
  constructor(props) {
    console.warn = () => { }
    super(props);
    this.state = {
      isLoad: true,
    };
  }
  componentDidMount() {
    setHistory(this.props.history);
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsingUser = JSON.parse(storedUser);
        this.props.updateUserInfo(parsingUser);
      } catch (e) {
        console.log('parseError' + e);
      }

    }
  }

  render() {

    var res = window.location.pathname;
    var baseUrl = process.env.PUBLIC_URL;
    baseUrl = baseUrl.split("/");
    res = res.split("/");
    res = res.length > 0 ? res[baseUrl.length] : "/";
    res = res ? res : "/";
    const activeKey1 = res || "/";
    const managementSections = [
      "customers-all", "customer-add", "customer-detail", "suppliers", "supplier-detail", "supplier-payment-add", "supplier-payment-detail",
      "vehicles", "vehicle-add", "vehicle-detail", "motos", "moto-add", "moto-detail",
      "incomes", "income-add", "income-detail", "expenses", "expense-add", "expense-detail", "income-expense-categories", "income-expense-categories-add", "income-expense-categories-detail",
      "receivables", "receivables-suppliers", "receivable-add", "receivable-detail", "receivable-supplier-add", "receivable-supplier-detail",
      "bank-accounts", "bank-account-detail", "stock", "buy-ai-credit", "labor-commissions"
    ];
    const isManagementSurface = managementSections.includes(activeKey1);
    if (activeKey1 === 'ai' || activeKey1 === 'appchat') {
      return <Redirect to={`${process.env.PUBLIC_URL}/assistant`}/>;
    }
    if (activeKey1 === 'assistant') {
      return <div id="wrapper" className="assistant-wrapper"><ToastContainer limit={3}/><PrivateRoute exact path={`${process.env.PUBLIC_URL}/assistant`} component={Assistant}/></div>;
    }

    return (

      <div id="wrapper">
        <ToastContainer limit={3} />
        {activeKey1 === "" ||
          activeKey1 === "/" ||
          activeKey1 === "login" ||
          activeKey1 === "registration" ||
          activeKey1 === "lockscreen" ||
          activeKey1 === "forgotpassword" ||
          activeKey1 === "page404" ||
          activeKey1 === "page403" ||
          activeKey1 === "page500" ||
          activeKey1 === "page503" ||
          activeKey1 === "show-service-invoice" ||
          activeKey1 === "show-earsiv-invoice" ||
          activeKey1 === "show-service-document" ||
          activeKey1 === "maintanance" ? (
          <Switch>
            {/* <Route exact path={`${process.env.PUBLIC_URL}`} component={Login} /> */}
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/`}
              component={Login}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/show-service-invoice/:id`}
              component={InvoiceHtmlShow}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/show-earsiv-invoice/:id`}
              component={EarsivInvoiceHtmlShow}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/show-service-document/:id`}
              component={DocumentHtmlShow}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/login`}
              component={Login}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/forgotpassword`}
              component={forgotpassword}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/page404`}
              component={page404}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/page403`}
              component={page403}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/page500`}
              component={page500}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/page503`}
              component={page503}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/registration`}
              component={registration}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/lockscreen`}
              component={lockscreen}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/maintanance`}
              component={maintanance}
            />
          </Switch>

        ) : (
          <>
            <NavbarMenu history={this.props.history} activeKey={activeKey1} />
            <div id="main-content" className={isManagementSurface ? "management-surface" : ""}>
              <Switch>
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/dashboard`}
                  component={dashboard}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/users`}
                  component={users}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/user-detail/:id`}
                  component={UserDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/user-add`}
                  component={UserAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/customers-all`}
                  component={Customers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/suppliers`}
                  component={Suppliers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/customer-detail/:id`}
                  component={CustomerDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/messages`}
                  component={Messages}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/messages/:customerId?`}
                  component={MessageDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/supplier-detail/:id`}
                  component={SupplierDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/customer-add`}
                  component={CustomerAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/branches`}
                  component={Branches}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/branch-add`}
                  component={BranchAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/branch-detail/:id`}
                  component={BranchDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/services`}
                  component={Services}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/service-add`}
                  component={ServiceAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/service-detail/:id`}
                  component={ServiceDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/appointments`}
                  component={Appointments}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/appointments/:id`}
                  component={AppointmentDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/services-moto`}
                  component={ServicesMotos}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/service-moto-add`}
                  component={ServiceMotoAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/service-moto-detail/:id`}
                  component={ServiceMotoDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vehicles`}
                  component={Vehicles}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/motos`}
                  component={Motos}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/moto-add`}
                  component={MotoAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vehicle-add`}
                  component={VehicleAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vehicle-detail/:id`}
                  component={VehicleDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/moto-detail/:id`}
                  component={MotoDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/operation-types`}
                  component={Types}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/operation-type-add`}
                  component={TypeAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/operation-type-detail/:id`}
                  component={TypeDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/status`}
                  component={Status}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/statu-add`}
                  component={StatuAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/statu-detail/:id`}
                  component={StatuDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/offers`}
                  component={Offers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/offer-add`}
                  component={OfferAdd}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/offer-preview`}
                  component={OfferPreview}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/offer-detail/:id`}
                  component={OfferDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/business`}
                  component={Business}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/integration-accounts`}
                  component={EmailAndSms}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/notification-prefers`}
                  component={NotificationPrefers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/roles`}
                  component={Roles}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/role-add`}
                  component={RoleAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/role-detail/:id`}
                  component={RoleDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/subscription`}
                  component={Subsciption}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/subscription/detail`}
                  component={MySubsciption}
                />
                {/* HIDDEN ADMIN ROUTE - No UI menu link, direct URL access only */}
                {/* Backend middleware checks ADMIN_EMAILS from .env */}
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/admin/pricing-management`}
                  component={PricingManagement}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/admin/campaign-management`}
                  component={CampaignManagement}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/admin/vehicle-avatars`}
                  component={VehicleAvatarManagement}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/admin/vehicle-brands`}
                  component={VehicleBrandManagement}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/service-reports`}
                  component={ServiceReports}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/reports-center`}
                  component={ReportsCenter}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/customer-reports`}
                  component={CustomerReports}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/finance-reports`}
                  component={FinanceReports}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/finance-income-expense-report`}
                  component={IncomeExpenseReports}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/finance-receivable-report`}
                  component={ReceivableReports}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/tickets`}
                  component={Tickets}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/ticket-add`}
                  component={TicketAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/ticket-detail/:id`}
                  component={TicketDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/incomes`}
                  component={Incomes}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/income-add`}
                  component={IncomeAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/income-detail/:id`}
                  component={IncomeDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/expenses`}
                  component={Expenses}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/expense-add`}
                  component={ExpenseAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/expense-detail/:id`}
                  component={ExpenseDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/income-expense-categories`}
                  component={Categories}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/income-expense-categories-add`}
                  component={CategoryAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/income-expense-categories-detail/:id`}
                  component={CategoryDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/receivables`}
                  component={Receivables}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/receivables-suppliers`}
                  component={ReceivableSuppliers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/receivable-add`}
                  component={ReceivableAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/receivable-supplier-add`}
                  component={ReceivableSupplierAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/supplier-payment-add`}
                  component={SupplierPaymentAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/receivable-detail/:id`}
                  component={ReceivableDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/receivable-supplier-detail/:id`}
                  component={ReceivableSupplierDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/supplier-payment-detail/:id`}
                  component={SupplierPaymentDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/bank-accounts`}
                  component={BankAccounts}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/bank-account-detail/:id`}
                  component={BankAccountDetails}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/qr-generate`}
                  component={QrGenerate}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/notifications`}
                  component={NotificationSendAndHistory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/app-notifications`}
                  component={IncomeNotificationHistory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/invoice/:id/:customer_id`}
                  component={InvoiceDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/invoice-detail/:invoice_id`}
                  component={InvoiceDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/service-invoices`}
                  component={ServiceInvoices}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/service-invoices/:status`}
                  component={ServiceInvoicesByStatus}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/manual-invoices`}
                  component={ManualInvoiceList}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/manual-invoice`}
                  component={ManualInvoice}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/manual-invoice-detail/:id`}
                  component={ManualInvoiceDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/credits`}
                  component={Credits}
                />
                {/*
                  <PrivateRoute
                      exact
                      path={`${process.env.PUBLIC_URL}/sales-invoices`}
                      component={SalesInvoice}
                  />
                  */}

                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/documents`}
                  component={Documents}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/document-detail/:id`}
                  component={DocumentDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/einbox`}
                  component={EInvoiceInbox}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/einbox-detail/:id`}
                  component={EInvoiceInboxDetails}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/service-add-ai`}
                  component={ServiceAddWithAI}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/buy-ai-credit`}
                  component={BuyAiCredits}
                />
                <PrivateRoute exact path={`${process.env.PUBLIC_URL}/labor-commissions`} component={LaborCommissions} />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/search-parts`}
                  component={SearchParts}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/warehouses`}
                  component={Warehouses}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/warehouse-add`}
                  component={WarehouseAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/warehouse-detail/:id`}
                  component={WarehouseDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/items`}
                  component={StockItems}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/item-add`}
                  component={StockItemAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/categories`}
                  component={StockCategories}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/category-add`}
                  component={StockCategoryAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/category-detail/:id`}
                  component={StockCategoryDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/item-detail/:id`}
                  component={StockItemDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/movements`}
                  component={StockMovements}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/movement-add`}
                  component={StockMovementAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/movement-detail/:id`}
                  component={StockMovementDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/transfers`}
                  component={StockTransfers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/transfer-add`}
                  component={StockTransferAdd}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/transfer-detail/:id`}
                  component={StockTransferDetail}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/alerts`}
                  component={StockAlerts}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/reports/low-stock`}
                  component={LowStockReport}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/reports/sales`}
                  component={SalesReport}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/reports/summary`}
                  component={StockSummaryReport}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/reports/warehouse`}
                  component={WarehouseStockReport}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/stock/reports/movements`}
                  component={StockMovementReport}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/page404`}
                  component={page404}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/demographic`}
                  component={demographic}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/ioT`}
                  component={ioT}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/appcalendar`}
                  component={appCalendar}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/apptaskbar`}
                  component={appTaskbar}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/page404`}
                  component={page404}
                />
                <Route
                  path="*"
                  render={() => <Redirect to={`${process.env.PUBLIC_URL}/page404`} />}
                />

              </Switch>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoggedin: state.loginReducer.isLoggedin,
  updateUserInfo: state.navigationReducer.updateUserInfo
});


export default withRouter(connect(mapStateToProps, { updateUserInfo, onLoggedin })(App));
